import {
  infoColor,
  dangerColor,
  successColor,
  grayColor,
  defaultFont
} from "assets/jss/index.js";

const customSelectStyle = {

  selectMenu: {
    fontSize: ".5rem"
    // color: "#3C4858",
    // padding: "12px 0 7px",
    // fontSize: ".75rem",
    // fontWeight: 400,
    // lineHeight: 1.42857,
    // letterSpacing: 0,
    // // textTransform: "uppercase",
    // textDecoration: "none",
    //
    // '&,&:after': {
    //   borderBottomColor: infoColor[0] + " !important"
    // }
  },
  selectMenuItem: {
    clear: "both",
    color: "#333",
    margin: "0 5px",
    display: "block",
    padding: "3px 10px",
    transition: "all 150ms linear",
    fontWeight: 400,
    lineHeight: 2,
    whiteSpace: "nowrap",
    borderRadius: "2px",
    fontSize: ".85rem",
    minHeight: "inherit",
  },
  selectMenuItemSelected: {
    color: "#FFF",
    backgroundColor: infoColor[0] + " !important",
  },

  labelRoot: {
    ...defaultFont,
    color: grayColor[3] + " !important",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "1.42857",
    letterSpacing: "unset"
  },
  labelRootError: {
    color: dangerColor[0]
  },
  labelRootSuccess: {
    color: successColor[0]
  },
  formControl: {
    paddingBottom: "10px",
    margin: "10px 0 0 0",
    position: "relative",
    verticalAlign: "unset"
  },
};

export default customSelectStyle;
